import React from "react";

export const LocationTransform = data => {
  var newList = [];
  var newInstance;

  data.forEach((element, index) => {
    newInstance = {
      id: index,
      data: element.location
    };
    newList.push(newInstance);
  });

  return newList;
};

export const FixAreaTransform = data => {
  var newList = [];
  var newInstance;
  data.forEach((element, index) => {
    newInstance = {
      id: index,
      data: element.area,
      code: element.code
    };
    newList.push(newInstance);
  });

  return newList;
};

export const ItemCountTransform = data => {
  if (data.length > 1) {
    return <i>You have posted {data.length} fixes</i>;
  } else if (data.length === 1) {
    return <i>You have posted {data.length} fix</i>;
  } else {
    return <i>You haven't posted any fixes</i>;
  }
};

export const FilterData = (filter, data) => {
  if (filter === "Open"){
    return data.filter(fix => fix.status === "OPEN")
  } else if (filter === "Fixed"){
    return data.filter(fix => fix.status === "FIXED")
  } else {
    return data
  }
};

export const purgeData = () => {
  localStorage.removeItem("access");
  localStorage.removeItem("refresh");
}

export const storeTokens = (access, refresh) => {
  localStorage.setItem("access", access);
  localStorage.setItem("refresh", refresh);
}